module.exports = __webpack_public_path__ + "img/cert-career.1299a2b3.png";